

const style = {
    addContainer: {
        width: "100%",
        height: "100%",
        background: "rgba(200, 200, 200, 1)",
        boxShadow: "3px 3px 5px rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 28,
        fontWeight: 600,
        color: "rgba(120, 120, 120, 1)"
    }
}

export default style;